import { render, staticRenderFns } from "./CostPricesAdditionalServices.vue?vue&type=template&id=314bacaf&scoped=true"
import script from "./CostPricesAdditionalServices.vue?vue&type=script&lang=js"
export * from "./CostPricesAdditionalServices.vue?vue&type=script&lang=js"
import style0 from "./CostPricesAdditionalServices.vue?vue&type=style&index=0&id=314bacaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314bacaf",
  null
  
)

export default component.exports